import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ZWIFT_MAPS_ASSET } from '../utils/zwiftAssets';

// Before/after pairs for signature Zwift worlds, from the Firebase Storage folder
// assets/zwift_maps (named `<Map>_portrait_<n>_original.png` / `_2D.png`). Worlds
// were picked where the broken Strava map is most obviously wrong. Every slot shows
// a styled placeholder until its real image loads, so the layout never jumps.
const WORLDS = [
  {
    slug: 'watopia',
    name: 'Watopia',
    before: 'Watopia_portrait_5_original.png',
    after: 'Watopia_portrait_5_2D.png',
  },
  {
    slug: 'new-york',
    name: 'New York',
    before: 'NewYork_portrait_4_original.png',
    after: 'NewYork_portrait_4_2D.png',
  },
  {
    slug: 'crit-city',
    name: 'Crit City',
    before: 'CritCity_portrait_1_original.png',
    after: 'CritCity_portrait_1_2D.png',
  },
  {
    slug: 'scotland',
    name: 'Scotland',
    before: 'Scotland_portrait_1_original.png',
    after: 'Scotland_portrait_1_2D.png',
  },
  {
    slug: 'makuri-islands',
    name: 'Makuri Islands',
    before: 'MakuriIslands_portrait_2_original.png',
    after: 'MakuriIslands_portrait_2_2D.png',
  },
];

const ZwiftWorldGallery = () => {
  const { t } = useTranslation();
  const [loaded, setLoaded] = useState({}); // { 'watopia_before': true, ... }

  const markLoaded = (key) =>
    setLoaded((prev) => (prev[key] ? prev : { ...prev, [key]: true }));

  const renderSlot = (world, which, tagLabel, tagClass) => {
    const key = `${world.slug}_${which}`;
    return (
      <div className={`zfix-world-img zfix-world-${which}`}>
        <div className={`zfix-world-placeholder zfix-world-placeholder-${which}`} aria-hidden="true" />
        <img
          src={ZWIFT_MAPS_ASSET(world[which])}
          alt={which === 'after' ? world.name : ''}
          className={`zfix-world-real ${loaded[key] ? 'loaded' : ''}`}
          onLoad={() => markLoaded(key)}
        />
        <span className={`zfix-world-tag ${tagClass}`}>{tagLabel}</span>
      </div>
    );
  };

  return (
    <div className="section-darker zfix-worlds-section">
      <div className="section-inner">
        <div className="challenge-section">
          <div className="section-header-centered">
            <h2>{t('fixPage.worldsTitle', 'Your real Zwift map on Strava')}</h2>
            <p className="section-description">
              {t('fixPage.worldsDesc', 'The actual Zwift world map, on your Strava activity, for every world you ride.')}
            </p>
          </div>

          <div className="zfix-worlds-grid">
            {WORLDS.map((w) => (
              <figure key={w.slug} className="zfix-world-card">
                <div className="zfix-world-pair">
                  {renderSlot(w, 'before', t('fixPage.beforeShort', 'Before'), '')}
                  {renderSlot(w, 'after', t('fixPage.afterShort', 'After'), 'zfix-world-tag-after')}
                </div>
                <figcaption className="zfix-world-name">{w.name}</figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ZwiftWorldGallery;
